export default __webpack_public_path__ + "static/media/8827.bc5d96a7.svg";